import { Card, PlayerPosition, Rank, Suit } from './types';

// Define the two range sets
export const RESTRICTED_HAND_RANGE: string[] = [
   'AA', 'KK', 'QQ', 'JJ', 'TT', '99', '88',
   'AKs', 'AQs', 'AJs', 'ATs', 'KQs', 'KJs',
   'AKo', 'AQo', 'AJo'
];

const FULL_HAND_RANGE: string[] = [
   // All pocket pairs
   'AA', 'KK', 'QQ', 'JJ', 'TT', '99', '88', '77', '66', '55', '44', '33', '22',
   // All suited hands
   'AKs', 'AQs', 'AJs', 'ATs', 'A9s', 'A8s', 'A7s', 'A6s', 'A5s', 'A4s', 'A3s', 'A2s',
   'KQs', 'KJs', 'KTs', 'K9s', 'K8s', 'K7s', 'K6s', 'K5s', 'K4s', 'K3s', 'K2s',
   'QJs', 'QTs', 'Q9s', 'Q8s', 'Q7s', 'Q6s', 'Q5s', 'Q4s', 'Q3s', 'Q2s',
   'JTs', 'J9s', 'J8s', 'J7s', 'J6s', 'J5s', 'J4s', 'J3s', 'J2s',
   'T9s', 'T8s', 'T7s', 'T6s', 'T5s', 'T4s', 'T3s', 'T2s',
   '98s', '97s', '96s', '95s', '94s', '93s', '92s',
   '87s', '86s', '85s', '84s', '83s', '82s',
   '76s', '75s', '74s', '73s', '72s',
   '65s', '64s', '63s', '62s',
   '54s', '53s', '52s',
   '43s', '42s',
   '32s',
   // All offsuit hands
   'AKo', 'AQo', 'AJo', 'ATo', 'A9o', 'A8o', 'A7o', 'A6o', 'A5o', 'A4o', 'A3o', 'A2o',
   'KQo', 'KJo', 'KTo', 'K9o', 'K8o', 'K7o', 'K6o', 'K5o', 'K4o', 'K3o', 'K2o',
   'QJo', 'QTo', 'Q9o', 'Q8o', 'Q7o', 'Q6o', 'Q5o', 'Q4o', 'Q3o', 'Q2o',
   'JTo', 'J9o', 'J8o', 'J7o', 'J6o', 'J5o', 'J4o', 'J3o', 'J2o',
   'T9o', 'T8o', 'T7o', 'T6o', 'T5o', 'T4o', 'T3o', 'T2o',
   '98o', '97o', '96o', '95o', '94o', '93o', '92o',
   '87o', '86o', '85o', '84o', '83o', '82o',
   '76o', '75o', '74o', '73o', '72o',
   '65o', '64o', '63o', '62o',
   '54o', '53o', '52o',
   '43o', '42o',
   '32o'
];
// these numbers are pulled out the arse of gpt 4.1
export const FULL_RANGE_EV: number[] = [
   // 'AA', 'KK', 'QQ', 'JJ', 'TT', '99', '88', '77', '66', '55', '44', '33', '22',
   2.32, 2.19, 2.06, 1.93, 1.80, 1.67, 1.55, 1.43, 1.31, 1.20, 1.09, 0.98, 0.87,
   // 'AKs', 'AQs', 'AJs', 'ATs', 'A9s', 'A8s', 'A7s', 'A6s', 'A5s', 'A4s', 'A3s', 'A2s',
   1.67, 1.52, 1.36, 1.21, 1.08, 0.96, 0.85, 0.75, 0.65, 0.56, 0.47, 0.39,
   // 'KQs', 'KJs', 'KTs', 'K9s', 'K8s', 'K7s', 'K6s', 'K5s', 'K4s', 'K3s', 'K2s',
   1.41, 1.25, 1.10, 0.96, 0.83, 0.72, 0.61, 0.52, 0.44, 0.36, 0.29,
   // 'QJs', 'QTs', 'Q9s', 'Q8s', 'Q7s', 'Q6s', 'Q5s', 'Q4s', 'Q3s', 'Q2s',
   1.17, 1.01, 0.87, 0.74, 0.62, 0.51, 0.42, 0.33, 0.25, 0.17,
   // 'JTs', 'J9s', 'J8s', 'J7s', 'J6s', 'J5s', 'J4s', 'J3s', 'J2s',
   0.99, 0.84, 0.70, 0.57, 0.46, 0.36, 0.27, 0.20, 0.15,
   // 'T9s', 'T8s', 'T7s', 'T6s', 'T5s', 'T4s', 'T3s', 'T2s',
   0.83, 0.68, 0.55, 0.43, 0.33, 0.24, 0.17, 0.12,
   // '98s', '97s', '96s', '95s', '94s', '93s', '92s',
   0.69, 0.56, 0.43, 0.32, 0.23, 0.16, 0.11,
   // '87s', '86s', '85s', '84s', '83s', '82s',
   0.57, 0.46, 0.35, 0.25, 0.18, 0.13,
   // '76s', '75s', '74s', '73s', '72s',
   0.48, 0.37, 0.27, 0.19, 0.12,
   // '65s', '64s', '63s', '62s',
   0.38, 0.28, 0.20, 0.14,
   // '54o', '53o', '52o',
   0.28, 0.26, 0.24,
   // '43o', '42o',
   0.21, 0.20,
   // '32o'
   0.18,

   // 'AKo', 'AQo', 'AJo', 'ATo', 'A9o', 'A8o', 'A7o', 'A6o', 'A5o', 'A4o', 'A3o', 'A2o',
   1.53, 1.37, 1.22, 1.08, 0.95, 0.84, 0.73, 0.62, 0.53, 0.44, 0.36, 0.28,
   // 'KQo', 'KJo', 'KTo', 'K9o', 'K8o', 'K7o', 'K6o', 'K5o', 'K4o', 'K3o', 'K2o',
   1.26, 1.10, 0.95, 0.82, 0.70, 0.59, 0.49, 0.40, 0.32, 0.24, 0.17,
   // 'QJo', 'QTo', 'Q9o', 'Q8o', 'Q7o', 'Q6o', 'Q5o', 'Q4o', 'Q3o', 'Q2o',
   1.03, 0.87, 0.74, 0.62, 0.51, 0.41, 0.32, 0.24, 0.17, 0.10,
   // 'JTo', 'J9o', 'J8o', 'J7o', 'J6o', 'J5o', 'J4o', 'J3o', 'J2o',
   0.83, 0.68, 0.55, 0.44, 0.34, 0.25, 0.18, 0.11, 0.05,
   // 'T9o', 'T8o', 'T7o', 'T6o', 'T5o', 'T4o', 'T3o', 'T2o',
   0.65, 0.52, 0.40, 0.30, 0.21, 0.13, 0.06, 0.00,
   // '98o', '97o', '96o', '95o', '94o', '93o', '92o',
   0.51, 0.39, 0.28, 0.18, 0.09, 0.02, 0.01,
   // '87o', '86o', '85o', '84o', '83o', '82o',
   0.39, 0.29, 0.19, 0.11, 0.04, 0.02,
   // '76o', '75o', '74o', '73o', '72o',
   0.29, 0.20, 0.12, 0.07, 0.02,
   // '65o', '64o', '63o', '62o',
   0.20, 0.12, 0.05, 0.02,
   // '54o', '53o', '52o',
   0.12, 0.08, 0.03,
   // '43o', '42o',
   0.05, 0.02,
   // '32o'
   0.02
];

export const FULL_HAND_RANGE_SORTED_BY_EV: string[] = FULL_HAND_RANGE
.map((hand, idx) => ({ hand, ev: FULL_RANGE_EV[idx] }))
.sort((a, b) => b.ev - a.ev)
.map(item => item.hand)
console.log("FULL SORTED RANGE: " + FULL_HAND_RANGE_SORTED_BY_EV);

if (FULL_HAND_RANGE.length !== FULL_RANGE_EV.length) {
   console.error("FULL_RANGE.length: " + FULL_HAND_RANGE.length + " !== FULL_RANGE_EV.length: " + FULL_RANGE_EV.length);
}

// Function to parse hand notation from string format
function parseHandNotation(notation: string): { ranks: [Rank, Rank], suited: boolean } {
   if (notation.length === 2) {
      // Pocket pair (e.g., 'AA')
      const rank = notation[0] as Rank;
      return { ranks: [rank, rank], suited: false };
   } else if (notation.length === 3) {
      // Suited or offsuit hand (e.g., 'AKs' or 'AKo')
      const rank1 = notation[0] as Rank;
      const rank2 = notation[1] as Rank;
      const suited = notation[2] === 's';
      return { ranks: [rank1, rank2], suited };
   }
   throw new Error(`Invalid hand notation: ${notation}`);
}

// Function to determine if a hand is in the allowed range
export function isHandInRange(hand: Card[], allowedRange: string[]): boolean {
   if (hand.length !== 2) return false;

   // Sort cards by rank (higher rank first)
   const ranks = ['A', 'K', 'Q', 'J', 'T', '9', '8', '7', '6', '5', '4', '3', '2'];
   const sortedHand = [...hand].sort((a, b) => ranks.indexOf(a.rank) - ranks.indexOf(b.rank));

   // Check if it's a pocket pair
   if (sortedHand[0].rank === sortedHand[1].rank) {
      return allowedRange.includes(`${sortedHand[0].rank}${sortedHand[1].rank}`);
   }

   // Check if it's suited or offsuit
   const suited = sortedHand[0].suit === sortedHand[1].suit;
   const notation = `${sortedHand[0].rank}${sortedHand[1].rank}${suited ? 's' : 'o'}`;

   return allowedRange.includes(notation);
}

export function getSortedFullPokerHandArray(reducedSet: string[]) {
   // reducedSet example = ['22', '54s', '75s', '98o', 'A3o', 'J4s', 'J8o', 'K7o', 'K8o', 'Q2s', 'Q8o', 'T8o']
   //
   // assuming I have the above reduced set of poker hands,
   // and another list with every poker hand possibility: FULL_HAND_RANGE_SORTED_BY_EV
   // create a new array of poker hands that is sorted by the distance from each hand in the reduced set 
   // to the hand in the full range.
   // distance is defined by the number of incremental steps between each card.
   // e.g. 22 and 33 have a distance of 2 (+1, +1)
   // 98o and 98s have a distance of 1 (swap one card)
   // AK and QJ have a distance of 4 (-2, -2, magnitude is 4)
   // return the sorted array.

   const rankOrder: Record<string, number> = {'2':2,'3':3,'4':4,'5':5,'6':6,'7':7,'8':8,'9':9,'T':10,'J':11,'Q':12,'K':13,'A':14};

   function parseHand(hand: string) {
      let ranks = [hand[0], hand[1]].map(r => rankOrder[r]);
      let suited = hand[2] === 's' ? 's' : hand[2] === 'o' ? 'o' : '';
      if (!suited && hand.length === 2) suited = ''; // pocket pair
      return {ranks, suited};
   }

   function handDistance(a: string, b: string): number {
      let ha = parseHand(a);
      let hb = parseHand(b);

      // pairs
      if (ha.ranks[0] === ha.ranks[1] && hb.ranks[0] === hb.ranks[1]) {
         return Math.abs(ha.ranks[0] - hb.ranks[0]) * 2;
      }

      // normalize order
      ha.ranks = ha.ranks[0] >= ha.ranks[1] ? ha.ranks : [ha.ranks[1], ha.ranks[0]];
      hb.ranks = hb.ranks[0] >= hb.ranks[1] ? hb.ranks : [hb.ranks[1], hb.ranks[0]];

      const rankDist = Math.abs(ha.ranks[0] - hb.ranks[0]) + Math.abs(ha.ranks[1] - hb.ranks[1]);
      const suitedDist = ha.suited === hb.suited ? 0 : 1;

      return rankDist + suitedDist;
   }

   return FULL_HAND_RANGE_SORTED_BY_EV.slice().sort((a: string, b: string) => {
      // get min distance for each hand to reducedSet
      const minDistA = Math.min(...reducedSet.map(h => handDistance(a, h)));
      const minDistB = Math.min(...reducedSet.map(h => handDistance(b, h)));
      return minDistA - minDistB;
   });
}

// Function to interpolate between restricted and full range based on slider value
export function getInterpolatedRange(sliderValue: number, restrictedHandRange: string[]): string[] {
   console.log("sliderValue: " + sliderValue);

   if (sliderValue <= 0) return [...restrictedHandRange];
   if (sliderValue >= 100) return [...FULL_HAND_RANGE_SORTED_BY_EV];

   // TODO: !!! take playerPosition into account
   // use a reduced set of hands based on ranges

   // Calculate how many cards to include from the full range
   const restrictedCount = restrictedHandRange.length;
   const fullCount = FULL_HAND_RANGE_SORTED_BY_EV.length;
   const cardsToInclude = Math.floor(restrictedCount + (sliderValue / 100) * (fullCount - restrictedCount));

   // Get all cards from the full range that aren't in the restricted range
   const additionalCards = FULL_HAND_RANGE_SORTED_BY_EV.filter(card => !restrictedHandRange.includes(card));

   // Take a subset of additional cards based on slider value
   const additionalCardsToInclude = additionalCards.slice(0, cardsToInclude - restrictedCount);

   // Combine restricted range with the additional cards
   return [...restrictedHandRange, ...additionalCardsToInclude];
}

// // Function to convert the ranges to JSON format
// export function rangesToJson(): { restricted: string, full: string } {
//    return {
//       restricted: JSON.stringify(restrictedHandRange),
//       full: JSON.stringify(FULL_HAND_RANGE_SORTED_BY_EV)
//    };
// }

// Function to generate random cards within the specified range from a deck
// Cards are removed from the deck to prevent duplicates
export function generateRandomHand(allowedRange: string[], deck: Card[]): Card[] {
   if (allowedRange.length === 0) {
      throw new Error('No cards in allowed range');
   }

   // Try multiple times to find a valid hand from the deck
   const maxAttempts = 100;
   let attempts = 0;

   while (attempts < maxAttempts) {
      attempts++;

      // Pick a random hand notation from the allowed range
      const randomIndex = Math.floor(Math.random() * allowedRange.length);
      const randomNotation = allowedRange[randomIndex];

      // Parse the hand notation
      const { ranks, suited } = parseHandNotation(randomNotation);

      // Find available cards in the deck that match this hand
      const availableCards = findAvailableCardsForHand(deck, ranks, suited);
      
      if (availableCards.length >= 2) {
         // Remove the selected cards from the deck
         const card1 = availableCards[0];
         const card2 = availableCards[1];
         
         const card1Index = deck.findIndex(c => c.rank === card1.rank && c.suit === card1.suit);
         const card2Index = deck.findIndex(c => c.rank === card2.rank && c.suit === card2.suit);
         
         if (card1Index !== -1 && card2Index !== -1) {
            // Remove cards from deck (remove higher index first to avoid index shifting)
            if (card1Index > card2Index) {
               deck.splice(card1Index, 1);
               deck.splice(card2Index, 1);
            } else {
               deck.splice(card2Index, 1);
               deck.splice(card1Index, 1);
            }
            
            return [card1, card2];
         }
      }
   }

   throw new Error(`Could not generate a valid hand from the available deck after ${maxAttempts} attempts`);
}

// Helper function to find available cards that match a hand specification
function findAvailableCardsForHand(deck: Card[], ranks: [Rank, Rank], suited: boolean): Card[] {
   if (ranks[0] === ranks[1]) {
      // Pocket pair - find two cards with the same rank but different suits
      const availablePairs = deck.filter(card => card.rank === ranks[0]);
      if (availablePairs.length >= 2) {
         // Return the first two available cards with this rank
         return [availablePairs[0], availablePairs[1]];
      }
   } else if (suited) {
      // Suited hand - find cards with the specified ranks and same suit
      const suits: Suit[] = ['H', 'D', 'C', 'S'];
      for (const suit of suits) {
         const card1 = deck.find(c => c.rank === ranks[0] && c.suit === suit);
         const card2 = deck.find(c => c.rank === ranks[1] && c.suit === suit);
         if (card1 && card2) {
            return [card1, card2];
         }
      }
   } else {
      // Offsuit hand - find cards with the specified ranks and different suits
      const card1Options = deck.filter(c => c.rank === ranks[0]);
      const card2Options = deck.filter(c => c.rank === ranks[1]);
      
      for (const card1 of card1Options) {
         for (const card2 of card2Options) {
            if (card1.suit !== card2.suit) {
               return [card1, card2];
            }
         }
      }
   }
   
   return [];
}
